import { render } from "./FakeInput.vue?vue&type=template&id=c572cc14"
import script from "./FakeInput.vue?vue&type=script&lang=js"
export * from "./FakeInput.vue?vue&type=script&lang=js"
script.render = render

export default script